import React from "react";
import styles from "./styles.module.scss";

const InfoBanner = ({ header, text }) => {
  return (
    <div className={styles.container}>
      <div className={styles.text_container}>
        <div className={styles.header}>{header}</div>
        <div className={styles.list_container}>
          <ul className={styles.list}>
            {text.map((item, i) => (
              <li key={i}>
                <span className={styles.item}>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default InfoBanner;
